import { createContext } from 'react';

export interface FloatingHeaderContextProps {
  /**
   * Whether the overlay is open at the breakpoints defined in the `overlayBreakpoints` prop.
   * @default false
   */
  overlayIsOpen?: boolean;
  /**
   * Determines whether the horizontal menu will be shown. If false, the vertical menu will be displayed.
   * @default false
   */
  showHorizontalMenu: boolean;
}

export const FloatingHeaderContext = createContext<FloatingHeaderContextProps>({
  overlayIsOpen: false,
  showHorizontalMenu: false,
});
